import * as avatars from "./avatars";
import * as content from "./content";
import * as create from "./create";
import * as landing from "./landing";
import * as onboarding from "./onboarding";
import * as profile from "./profile";

export const gtmService = {
  ...landing,
  ...avatars,
  ...create,
  ...content,
  ...profile,
  ...onboarding,
};
